import { buildWaitlistFunnelParams, type WaitlistFormLocation } from '@/wabunka-src/common/utils/googleAnalytics/common/waitlistFunnel';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

/**
 * 発火タイミング：ウェイトリスト登録 API が成功した時
 */
export const sendGAWabunkaWaitlistRegisterEvent = (experienceSlug: string, location: WaitlistFormLocation) => {
  sendWabunkaGAEvent('waitlist_register', buildWaitlistFunnelParams(experienceSlug, location));
};
